import './styles.scss';

export default {
    name: 'MessagingComposeMessagePage',

    data() {
        return {
            message: ' '
        }
    },

    computed: {
        subscription() {
            return this.$store.state.subscriptions.active_subscription;
        },

        stored_message() {
            return this.$store.state.messaging.message;
        }
    },

    created() {
        const back_url = this.$store.state.messaging.message_type !== 'new' ? '/action/emergency-messages/available-messages' : '/action/emergency-messages/choose-message';
        
        this.$store.commit('setMenuDetails', { 
            title: 'Emergency Messages', 
            slug: 'messaging',
            back_url: back_url
        });

        this.message = this.stored_message;
    },

    methods: {
        update(message) {
            this.message = message;
            this.$store.commit('setMessage', message);
        },

        next() {
            this.$store.commit('setMessage', this.message);
            this.$router.push('/action/emergency-messages/preview');
        },

        cancel() {
            this.$ionic.alertController.create({
                header: 'Are you sure you want to cancel?',
                message: 'This action cannot be undone.',
                buttons: [
                    {
                        text: 'Yes',
                        handler: () => {
                            this.$store.commit('resetMessage');
                            this.$router.push('/action');
                        },
                    },
                    {
                        text: 'No',
                        role: 'cancel'
                    }
                ],
            }).then(a => a.present());
        }
    }
};